/**
 * Đơn vị trong danh mục tham số → mã đơn vị của giao diện.
 *
 * `settings-registry.yaml` viết đơn vị bằng tiếng Việt (`phút`, `ký tự`), là
 * chuỗi dữ liệu chứ không phải khoá dịch. Bảng này nằm ở `nghiep-vu/` vì nó
 * phải chứa đúng các chuỗi tiếng Việt đó; `constants.ts` ánh xạ tiếp mã → khoá
 * dịch. Đơn vị chưa có ở đây thì giao diện hiện nguyên văn.
 */
import type { SettingDefinition } from './types.ts';

export type MaDonVi = 'phut' | 'lan' | 'kyTu' | 'ngay' | 'thang' | 'suKienS';

const BANG: Record<string, MaDonVi> = {
  'phút': 'phut',
  'lần': 'lan',
  'ký tự': 'kyTu',
  'ngày': 'ngay',
  'tháng': 'thang',
  'sự kiện/s': 'suKienS',
};

export function maDonVi(unit: string | null | undefined): MaDonVi | null {
  return unit ? (BANG[unit.trim()] ?? null) : null;
}

/**
 * Tham số là tỉ lệ (0..1) — hiện và nhập theo phần trăm.
 *
 * Danh mục không khai đơn vị cho tỉ lệ lấy mẫu audit; nhận ra bằng kiểu
 * `number` có trần 1.
 */
export function laTiLe(def: Pick<SettingDefinition, 'type' | 'bounds'>): boolean {
  return def.type === 'number' && def.bounds?.max === 1;
}
